import React, {useEffect, useState} from 'react';

export default function UseScrollButtonsStatus(ref, items) {

  const [rightEnabled, setRightEnabled] = useState(false);
  const [leftEnabled, setLeftEnabled] = useState(false);

  function scrollButtonsStatusListener(e) {
    setRightEnabled((ref.current.scrollWidth - ref.current.scrollLeft) > ref.current.clientWidth);
    setLeftEnabled(ref.current.scrollLeft > 0);
  }

  useEffect( () => {
    if(! ref.current) return;
    scrollButtonsStatusListener();
  }, [items]);

  useEffect(() => {
    if (! ref.current) return;

    ref.current.addEventListener('scroll', scrollButtonsStatusListener);
    window.addEventListener('resize', scrollButtonsStatusListener);

    return function() {
      ref.current.removeEventListener('scroll', scrollButtonsStatusListener);
      window.removeEventListener('resize', scrollButtonsStatusListener);
    }
  }, []);


  function scrollContainer(dir) {

    let elem = ref.current;
    // We give precedence to the second child element because the first one
    // could be a padding div.
    let itemWidth = elem.children[1] !== undefined
      ? elem.children[1].clientWidth
      : elem.firstElementChild.clientWidth;

    let scrollL = elem.scrollLeft;

    let currentCard = Math.ceil(scrollL / itemWidth);
    let visibleAmount = (itemWidth * currentCard) - scrollL;
    let hiddenAmount = itemWidth - visibleAmount;

    let scrolled = 0;
    let increment = 0;

    let amount  = scrollL % itemWidth
      ? dir === 'right' ? visibleAmount : hiddenAmount
      : itemWidth;

    const progression = () => (scrolled + increment) > amount ? amount - scrolled : increment + 1;

    const move = () => {
      increment = progression();
      elem.scrollLeft+= dir === 'right' ? increment : -increment;
      scrolled+=increment;
    };


    let timer = setInterval(function() {
      if (scrolled >= amount) {
        clearInterval(timer);
        return;
      }
      move();
    }, 10);

  }

  return [leftEnabled, rightEnabled, scrollContainer];
};
